import { Location } from 'history';
import { Query } from '../../../definitions/query';
import { QUERY_STRING } from '../../../enums/QueryString';
import { RoomType } from '../../../enums/RoomTypes';

/**
 * Try to detect the room type from the url, as it's the only way to know
 * BEFORE loading the room data, in order for the skeleton loader to use
 * the proper layout, for a room or a content link.
 *
 * The expectation is to have a URL like this:
 *  - https://{domain}/room/{uuid}
 *  - https://{domain}/content-link/{uuid}
 */
export const getRoomType = (location: Location): RoomType =>
  location.pathname.split('/')[1].replace(/-/g, '_') as RoomType;

/**
 * Reference to the query string params that must be kept after refreshing
 * the page in case an anonymous visitor has been deeplinked to an
 * action plan task or message. This allows the expected behavior to
 * occurr after the anonymous visitor has entered an email
 */
export const getRefreshQueryParams = (query: Query) => ({
  [QUERY_STRING.ACTION_PLAN_ID]: query[QUERY_STRING.ACTION_PLAN_ID],
  [QUERY_STRING.ACTION_PLAN_TASK_ID]: query[QUERY_STRING.ACTION_PLAN_TASK_ID],
  [QUERY_STRING.ACTION_PLAN_TASK_MSG_ID]:
    query[QUERY_STRING.ACTION_PLAN_TASK_MSG_ID],
  [QUERY_STRING.SECTION]: query[QUERY_STRING.SECTION],
  [QUERY_STRING.REFERRER]: query[QUERY_STRING.REFERRER],
  [QUERY_STRING.ROOM_MESSAGE_ID]: query[QUERY_STRING.ROOM_MESSAGE_ID],
});

/**
 * Appends or replaces `section` on a room view URL for deep-linking.
 */
export const appendSectionDeepLink = (
  baseUrl: string,
  sectionId: string
): string => {
  const url = new URL(
    baseUrl,
    typeof window !== 'undefined' ? window.location.origin : undefined
  );
  url.searchParams.set(QUERY_STRING.SECTION, sectionId);
  return url.toString();
};
